import React, { useEffect, useState } from "react";
import Logo from "../../Assets/Images/Logo-xsmall.svg";
import Lock from "../../Assets/Images/Lock.svg";
import LockActive from "../../Assets/Images/lock-active.svg";
import User from "../../Assets/Images/User.svg";
import UserActive from "../../Assets/Images/user-active.svg";
import AuthTextInput from "../Dashboard/Components/ShareElements/TextInput/AuthTextInput";
import { BrowserRouter, useParams } from "react-router-dom";
import Alert from "../../Assets/Images/alert-triangle.svg";
import axios from "axios";
import { Config } from "../../Config";
import LoginImage from "../../Assets/Images/Auth.svg";
import LoadingIcon from "../../Assets/Images/ButtonLoadingIcon.svg";

// Main Login page component
const Login = () => {
  const [PasswordIsShown, setPasswordIsShown] = useState(false);
  const [AttemptCounter, setCounter] = useState(1); //counter for wrong password attempts
  const [IsLoading, setIsLoading] = useState(false);

  //this parameter is gotten by the use of useParams hook (could be null or undefined if no redirect is done)
  let { Token } = useParams();

  useEffect(() => {
    console.log(Token);
    // removing previous localStorage items
    window.localStorage.removeItem("RedirectToken");
    // In case there's already a JWT token in the localStorage that is valid,
    // this function handles the redirection
    checkPreviosLoginStatus();
    // the token encoded as base64 that contains the data related to email redirect
    window.localStorage.setItem("RedirectToken", Token);
  }, []);

  const checkPreviosLoginStatus = () => {
    let PreviousToken = window.localStorage.getItem("Token");

    if (
      window.localStorage.getItem("SESSION_ENDED_ON_BROWSER_CLOSED") === "true"
    ) {
      window.localStorage.removeItem("Token");
      window.localStorage.removeItem("RefreshToken");
    } else if (PreviousToken !== null) {
      // making an API request to get the user's info whose token is stored in the localStorage
      let Req = {
        method: "GET",
        baseURL: window._env_.API_URL + Config.AuthBaseURL + "/api/profile",
        headers: {
          Authorization: "Bearer " + window.localStorage.getItem("Token"),
        },
      };
      axios(Req)
        .then((Res) => {
          console.log(Res);
          if (Token === undefined) {
            // no redirect token is detected
            window.location.assign("/home");
          } else {
            // Validating if this redirect token belongs to the owner
            // of the token stored in the localStorage
            var RedirectData = JSON.parse(atob(Token));
            if (RedirectData.loggedInEmployeeId === Res.data.id) {
              window.localStorage.setItem("RedirectToken", Token);
              window.location.assign("/home");
            }
          }
        })
        .catch((Err) => {
          console.log(Err);
        });
    }
  };

  const showPassword = () => {
    // Just in case any prev uploaded image exists in the local storag, we remove it.
    window.localStorage.removeItem("UploadedImage");

    setPasswordIsShown(!PasswordIsShown);
    if (PasswordIsShown) {
      document.getElementById("password").type = "password";
    } else {
      document.getElementById("password").type = "text";
    }
  };
  // This function is called when the user clicks the login button, it validates the entries and
  // responds accordingly, to handle empty username and password entery.
  const validateLogin = (e) => {
    e.preventDefault();
    setIsLoading(true);
    const Password = document.getElementById("password").value;
    const Username = document.getElementById("username").value;

    if (Password.length === 0 && Username.length === 0) {
      showEmptyCredsError();
      setIsLoading(false);
    } else if (Password.length === 0 && Username.length > 0) {
      showEmptyPasswordError();
      setIsLoading(false);
    } else if (Password.length > 0 && Username.length === 0) {
      showEmptyUsernameError();
      setIsLoading(false);
    } else {
      logUserIn();
    }
  };
  // After the validation, if the entries are fine, this function is called to log the user in
  const logUserIn = () => {
    var Credentials = new FormData();
    Credentials.append("username", document.getElementById("username").value);
    Credentials.append("password", document.getElementById("password").value);
    Credentials.append("grant_type", "password");
    var Request = {
      method: "POST",
      baseURL: window._env_.API_URL + Config.AuthBaseURL + "/oauth/token",
      headers: {
        Authorization: "Basic " + Config.IdentityToken,
      },
      data: Credentials,
    };
    axios(Request)
      .then((Res) => {
        window.localStorage.setItem("Token", Res.data.access_token);
        window.localStorage.setItem("RefreshToken", Res.data.refresh_token);
        window.localStorage.setItem("showChatbotOnBoardingBanner", "1"); // "": false, "1":true
        setIsLoading(false);
        checkFirstLogin();
      })
      .catch((Err) => {
        setIsLoading(false);
        console.log(Err.response);
        handleLoginErrors(Err.response);
      });
  };
  const checkFirstLogin = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL + Config.AuthBaseURL + "/api/profile/first-login",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        if (Res.data.firstLogin) {
          window.location.assign("/ChangePassword/" + Res.data.changePassToken);
        } else {
          checkWizardStatus();
        }
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };
  const checkWizardStatus = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL + Config.AuthBaseURL + "/api/profile/first-wizard",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        if (Res.data.firstWizard === null || Res.data.firstLogin === false) {
          window.location.assign("/SetupWizard");
        } else {
          window.location.assign("/home");
          window.localStorage.setItem("MenuIsOpen", 0); //0: false 1: true
        }
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  // This function receives the login API error response and handles the errors happening on login
  // inside this form other than empty entries which are handled in validateLogin function.
  const handleLoginErrors = (Err) => {
    if (Err !== undefined && Err.status === 400) {
      if (Err.data.error === "invalid_request") {
        // wrong email
        showUsernameError();
      }
      if (Err.data.error === "invalid_grant") {
        // wrong password
        if (AttemptCounter <= 3) {
          setCounter(AttemptCounter + 1);
        } else if (AttemptCounter >= 3) {
          disableEntries();
          document.getElementById("wrong-username").style.display = "none";
          document.getElementById("wrong-password").style.display = "none";
          window.localStorage.setItem(
            "LockedUsername",
            document.getElementById("username").value
          );
        }
        showPasswordError();
      }
      if (Err.data.error_description === "User account is locked") {
        disableEntries();
        document.getElementById("wrong-username").style.display = "none";
        document.getElementById("wrong-password").style.display = "none";
        window.localStorage.setItem(
          "LockedUsername",
          document.getElementById("username").value
        );
      }
    }
  };
  // The following functions are small functions that show or hide specific error messages
  // by adding and removing css class names to the classList of the elements by their Id.
  const showPasswordError = () => {
    document.getElementById("password-input").classList.add("wrong-input");
    document
      .getElementById("wrong-password")
      .classList.add("wrong-cridentials-message-is-shown");
  };
  const hidePasswordError = () => {
    document.getElementById("password-input").classList.remove("wrong-input");
    document
      .getElementById("wrong-password")
      .classList.remove("wrong-cridentials-message-is-shown");
  };
  const showUsernameError = () => {
    document.getElementById("username-input").classList.add("wrong-input");
    document
      .getElementById("wrong-username")
      .classList.add("wrong-cridentials-message-is-shown");
  };
  const hideUsernameError = () => {
    document.getElementById("username-input").classList.remove("wrong-input");
    document
      .getElementById("wrong-username")
      .classList.remove("wrong-cridentials-message-is-shown");
  };
  const showEmptyCredsError = () => {
    document
      .getElementById("empty-cridentials")
      .classList.add("wrong-cridentials-message-is-shown");
    document.getElementById("password-input").classList.add("wrong-input");
    document.getElementById("username-input").classList.add("wrong-input");
  };
  const hideEmptyCredsError = () => {
    document
      .getElementById("empty-cridentials")
      .classList.remove("wrong-cridentials-message-is-shown");
    document.getElementById("password-input").classList.remove("wrong-input");
    document.getElementById("username-input").classList.remove("wrong-input");
  };
  const showEmptyUsernameError = () => {
    document
      .getElementById("empty-username")
      .classList.add("wrong-cridentials-message-is-shown");
    document.getElementById("username-input").classList.add("wrong-input");
  };
  const hideEmptyUsernameError = () => {
    document
      .getElementById("empty-username")
      .classList.remove("wrong-cridentials-message-is-shown");
    document.getElementById("username-input").classList.remove("wrong-input");
  };
  const showEmptyPasswordError = () => {
    document
      .getElementById("empty-password")
      .classList.add("wrong-cridentials-message-is-shown");
    document.getElementById("password-input").classList.add("wrong-input");
  };
  const hideEmptyPasswordError = () => {
    document
      .getElementById("empty-password")
      .classList.remove("wrong-cridentials-message-is-shown");
    document.getElementById("password-input").classList.remove("wrong-input");
  };

  // this function applies all changes required after 3 wrong password attempts
  // The className disabled is defined in Auth.scss file and applies complementary styles to avoid
  // conflicts and apply styles to elements based on the status of being disabled.
  const disableEntries = () => {
    document.getElementById("auth-form").classList.add("disabled");
    document.getElementById("username").disabled = "true";
    document.getElementById("password").disabled = "true";
    document.getElementById("username").value = "";
    document.getElementById("password").value = "";
    document.getElementById("auth-vector").style.display = "none";
    document.getElementById("auth-disabled").style.display = "block";
  };
  const removeUsernameErrors = () => {
    hideUsernameError();
    hideEmptyUsernameError();
    hideEmptyCredsError();
    document
      .getElementById("wrong-username")
      .classList.remove("wrong-cridentials-message-is-shown");
  };
  const removePasswordErrors = () => {
    hidePasswordError();
    hideEmptyPasswordError();
    hideEmptyCredsError();
    document
      .getElementById("wrong-password")
      .classList.remove("wrong-cridentials-message-is-shown");
  };
  return (
    <BrowserRouter basename="/">
      <div className="auth-form" id="auth-form">
        <form>
          <img className="logo" alt="login" src={Logo} />
          <section className="alert">
            <img src={Alert} alt="!" className="alert-image" />
            <h3>Your Account is Locked.</h3>
            <p>
              You’ve entered too many wrong passwords. Please contact the Admin.
            </p>
          </section>
          <section className="mobile-login-banner">
            <p className="form-title">Sign In</p>
            <p className="info">Welcome back to your account.</p>
            <img src={LoginImage} className="is-mobile" />
          </section>
          <AuthTextInput
            Icon={User}
            ActiveIcon={UserActive}
            PlaceHolder="Username/Email"
            Id="username"
            type="text"
            BlurAction={() => removeUsernameErrors()}
          />
          <p className="wrong-cridentials-message" id="wrong-username">
            The username you’ve entered is wrong.
          </p>
          <p className="wrong-cridentials-message" id="empty-username">
            Enter your username.
          </p>
          <AuthTextInput
            Icon={Lock}
            ActiveIcon={LockActive}
            showPassword={() => showPassword()}
            PasswordIsShown={PasswordIsShown}
            Type="password"
            Id="password"
            PlaceHolder="Password"
            BlurAction={() => removePasswordErrors()}
          />
          <p className="wrong-cridentials-message" id="wrong-cridentials">
            The username or password you’ve entered is wrong.
          </p>
          <p className="wrong-cridentials-message" id="wrong-password">
            The password you’ve entered is wrong.
          </p>
          <p className="wrong-cridentials-message" id="empty-password">
            Enter your password.
          </p>

          <p className="wrong-cridentials-message" id="empty-cridentials">
            Enter username and password.
          </p>
          <section className="login-options">
            <label className="remember">
              {/* <label className="blue-checkbox-label">
                <input id="remember-me" type="checkbox" class="blue-checkbox" />
                <i></i>
              </label>
              Remember me */}
            </label>
            <a href="/ResetPassword" className="forget-password">
              Forgot password
            </a>
          </section>
          {IsLoading ? (
            <button className="login-btn disabled-btn">
              <img className="rotator" src={LoadingIcon} alt="" />
            </button>
          ) : (
            <button onClick={(e) => validateLogin(e)} className="login-btn">
              Log In
            </button>
          )}
        </form>
      </div>
    </BrowserRouter>
  );
};
export default Login;
